import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex h-screen" }
const _hoisted_2 = { class: "w-64 min-h-screen bg-gray-100 dark:bg-gray-900 border-r border-gray-300 dark:border-gray-700 transition-colors duration-200" }
const _hoisted_3 = { class: "p-4 border-b border-gray-300 dark:border-gray-700 bg-transparent" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_7 = { class: "flex items-center px-4 py-3 text-gray-600 dark:text-gray-300 font-medium" }
const _hoisted_8 = { class: "absolute bottom-0 w-64 p-4 border-t border-gray-300 dark:border-gray-700" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-center mb-3"
}
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "text-sm font-medium text-gray-800 dark:text-white" }
const _hoisted_12 = { class: "text-xs text-gray-600 dark:text-gray-400 max-w-[180px] truncate" }
const _hoisted_13 = { class: "flex items-center justify-between mb-3 px-1" }
const _hoisted_14 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-yellow-300 absolute right-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_15 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-blue-400 absolute left-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_16 = { class: "flex-1 overflow-auto bg-white dark:bg-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LogoutIcon = _resolveComponent("LogoutIcon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "flex items-center justify-center cursor-pointer p-1 logo-link"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "flex items-center" }, [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-9 w-9 mr-1",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  d: "M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z",
                  fill: "#FFD700",
                  stroke: "#FFD700",
                  "stroke-width": "0.5"
                })
              ]),
              _createElementVNode("div", { class: "flex items-center" }, [
                _createElementVNode("span", { class: "text-3xl font-bold text-blue-500" }, "dev"),
                _createElementVNode("span", { class: "text-3xl font-bold text-green-500" }, "tools")
              ])
            ], -1)
          ])),
          _: 1,
          __: [2]
        })
      ]),
      _createElementVNode("nav", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.name
            }, [
              ((item as FolderMenuItem).type === 'folder')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-5 h-5 mr-3" })),
                      _createElementVNode("span", null, _toDisplayString(item.name), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item as FolderMenuItem).children, (subItem) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: subItem.path,
                        to: subItem.path,
                        class: _normalizeClass(["flex items-center px-8 py-2 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-800", { 'bg-gray-200 dark:bg-gray-800 font-medium': _ctx.isActive(subItem.path) }])
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(subItem.icon), { class: "w-5 h-5 mr-3" })),
                          _createElementVNode("span", null, _toDisplayString(subItem.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class"]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: (item as RegularMenuItem).path,
                    class: _normalizeClass(["flex items-center px-4 py-3 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-800", {
                'bg-gray-200 dark:bg-gray-800 font-medium': _ctx.isActive((item as RegularMenuItem).path)
              }])
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-5 h-5 mr-3" })),
                      _createElementVNode("span", null, _toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
            ], 64))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "w-8 h-8 rounded-full flex items-center justify-center mr-2",
                style: _normalizeStyle({
              backgroundColor: _ctx.getUserColor,
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.875rem'
            })
              }, _toDisplayString(_ctx.getUserInitials), 5),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.user.name), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.user.email), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Theme", -1)),
          _createElementVNode("button", {
            class: "flex items-center justify-center rounded-full w-10 h-5 bg-gray-300 dark:bg-gray-600 relative",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.theme.toggleTheme && _ctx.theme.toggleTheme(...args)))
          }, [
            (_ctx.theme.isDark.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _cache[3] || (_cache[3] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                  }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock("svg", _hoisted_15, _cache[4] || (_cache[4] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                  }, null, -1)
                ]))),
            _createElementVNode("div", {
              class: _normalizeClass(["w-4 h-4 rounded-full absolute transition-all duration-300 transform bg-gray-200", _ctx.theme.isDark.value ? 'translate-x-2' : '-translate-x-2'])
            }, null, 2)
          ])
        ]),
        _createElementVNode("button", {
          class: "w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-rose-500 dark:bg-red-600 hover:bg-rose-600 dark:hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 dark:focus:ring-red-500 transition-colors duration-200",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
        }, [
          _createVNode(_component_LogoutIcon, { class: "w-4 h-4 mr-2" }),
          _cache[6] || (_cache[6] = _createTextVNode(" Logout "))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_router_view)
    ])
  ]))
}